import { Button, Modal } from "antd";
import React from "react";
import { svg } from "../../../../../Assets/svg";

interface Props {
  open: boolean;
  onClose: () => void;
  onUpdate: () => void;
}

const DropTbcWarningModal: React.FC<Props> = ({ open, onClose, onUpdate }) => {
  return (
    <Modal
      open={open}
      centered
      width={"33.75rem"}
      footer={null}
      onCancel={onClose}
      closeIcon={svg?.closeIcon}
      title={
        <div className="text-center fs-4 fw-bolder lh-m">
          Update Drop Configurations
        </div>
      }
      className="custom-modal"
    >
      <div className="d-flex flex-column gap-3 align-items-center">
        <p className="fs-6 text-center">
          This order contains items with unconfirmed drops (Drop TBC). Please
          update these variants to proceed.
        </p>
        <div className="d-flex justify-content-center gap-3">
          <Button
            onClick={onUpdate}
            className="btn btn-lg h-auto px-5 btn-primary"
          >
            Update
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DropTbcWarningModal;
